import Swiper, { Autoplay, Pagination, EffectFade } from 'swiper';

if (document.querySelector('.slider-promotion') != undefined) {
    let sliders = document.querySelectorAll('.slider-promotion');

    sliders.forEach(slider => {
        if (slider.querySelectorAll('.swiper-slide').length > 1) {
            new Swiper(slider, {
                modules: [Pagination, Autoplay, EffectFade],
                spaceBetween: 15,
                slidesPerView: 1,
                autoHeight: true,
                loop: true,
                autoplay: {
                    delay: 4000,
                },
                pagination: {
                    el: '.swiper-pagination',
                    type: 'bullets',
                    clickable: true,
                },
                effect: 'slide',
            });
        }
    });
}